import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [previousLocation, setPreviousLocation] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const rememberLocation = (location, scroll = 0) => {
    setPreviousLocation(location);
    setScrollPosition(scroll);
  };

  const goBackToPrevious = (navigate) => {
    if (previousLocation) {
      navigate(previousLocation);
      // Small delay to ensure navigation completes before scrolling
      setTimeout(() => {
        // Restore scroll position for any home page location (with or without hash)
        if (previousLocation.startsWith('/') && scrollPosition > 0) {
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      }, 150);
    } else {
      // Fallback to home page with work section hash
      navigate('/#work');
    }
  };

  const value = {
    previousLocation,
    scrollPosition,
    rememberLocation,
    goBackToPrevious
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};